module.exports = __webpack_public_path__ + "static/media/Shells_Landing_Coders.7e5c2a59.svg";